class MFRHeader {
    constructor( index, element ) {
        this.$element = $( element );
        const headerMobile = new MFRHeaderMobile( element );
        this.selectors = {
          megaMenu: "[data-mega-menu]",
          trigger: "[data-trigger]",
          wrapper: ".header__mega-menu-wrapper",
          innerWrapper: ".header__wrapper-inner",
          navLinks: ".mega-menu__links li",
          ctas: ".mega-menu__ctas li",
          childLink: "[data-filter]",
          grandChildLink: "[data-filter-trigger]",
          images: ".mega-menu__images",
          dropdownMenu: "[data-dropdown-menu]",
          dropdownChildLinks: ".dropdown-menu__inner a",
          cart: ".header__cart"
        }

        this.ease = "back";
        this.currentFilter;
        this.currentTimeline;

        this.initialize();
    }

    initialize() {
      this.$megaMenu = this.$element.find( this.selectors.megaMenu );
      this.$wrapper = this.$element.find( this.selectors.wrapper );
      this.$innerWrapper = this.$element.find( this.selectors.innerWrapper );
      this.$navLinks = this.$element.find( this.selectors.navLinks );
      this.$ctas = this.$element.find( this.selectors.ctas );
      this.$childLink = this.$element.find( this.selectors.childLink );
      this.$grandChildLink = this.$element.find( this.selectors.grandChildLink );
      this.$images = this.$element.find( this.selectors.images );
      this.$dropdownMenu = this.$element.find( this.selectors.dropdownMenu );
      this.$dropdownChildLinks = this.$element.find( this.selectors.dropdownChildLinks );
      this.$cart = this.$element.find( this.selectors.cart );

      this.initMegaMenu();
    }

    initMegaMenu() {
      // header enter animation
      // gsap.from( this.$element, {
      //   yPercent: -100,
      //   delay: 1,
      //   duration: 1,
      //   ease: this.ease
      // } );

      //mega menu functions
      // this.moveMegaMenu();
      // this.initMegaMenuAnimation();
      // this.initMegaMenuEvents();
      // this.initChildLinkEvents();

      // this.moveDropdownMenu();
      // this.initDropdownMenuuAnimation();
      // this.initDropdownMenuEvents();

      this.initCartTrigger();
    }

    moveMegaMenu() {
      this.$megaMenu.each( ( i, e ) => {
        $( e ).prependTo( this.$wrapper );
      } )
    }

    initMegaMenuAnimation() {

      this.megaMenuAnim = gsap.timeline({
        paused: true
      });

      gsap.set( this.$navLinks, {
        opacity: 0,
        xPercent: -100,
      })

      gsap.set( this.$ctas, {
        opacity: 0,
        scale: 0,
      })

      this.megaMenuAnim
        .to( this.$megaMenu, {
          scaleY: 1,
          ease: this.ease,
          duration: 0.4
        } )
        .to( this.$navLinks, {
          opacity: 1,
          xPercent: 0,
          stagger: 0.1,
          duration: 0.4,
          ease: this.ease
        }, "-=0.3" )
        .to( this.$ctas, {
          opacity: 1,
          scale: 1,
          stagger: 0.1,
          duration: 0.4,
          ease: this.ease
        }, "-=0.3" );
    }

    initMegaMenuEvents() {
      this.$megaMenu.each( ( i,e ) => {
        const id = $( e ).data( "mega-menu" );
        const triggerElem = this.$element.find( `[data-trigger="${ id }"]` );

        triggerElem.on( "mouseenter", () => this.enterAnimation( this.megaMenuAnim ) );
        triggerElem.on( "mouseleave", () => this.closeMegaMenu() );
        $( e ).on( "mouseenter", () => this.enterAnimation( this.megaMenuAnim ) );
        $( e ).on( "mouseleave", () => this.closeMegaMenu() );
      } );
    }

    initChildLinkEvents() {
      const timeline = gsap.timeline({
        paused: true,
      });
      timeline.fromTo(
        this.$megaMenu,
        {
          width: this.$megaMenu.width(),
        },
        {
          width: "100%",
        }
      );
      this.$childLink.each( (index, element) => {
        const filter = $(element).data("filter");
        const wrapper = $(`[data-filter-trigger="${filter}"]`);
        const wrapperTimeline = gsap.timeline({
          paused: true,
        });
        wrapperTimeline.fromTo(
          wrapper,
          {
            opacity: 0,
            display: "none",
            duration: 0.4,
          },
          {
            opacity: 1,
            display: "grid",
            duration: 0.4,
          }
        );
        $( element ).on("mouseenter", (e) => {
          wrapperTimeline.play();
          gsap.set(wrapper, { position: "relative" });
          // gsap.to( wrapper, {
          //   opacity: 1,
          //   display: "grid",
          //   position: "relative",
          //   duration: 0.4
          // } );
          timeline.play();
        })
        .on( "mouseleave", () => {
          wrapperTimeline.reverse();
          gsap.set( wrapper, { position: "absolute" } );
          // gsap.to(wrapper, {
          //   opacity: 0,
          //   display: "none",
          //   position: "absolute",
          //   duration: 0.4,
          // });
          timeline.reverse();
        } );
        wrapper
          .on( "mouseenter", () => {
            gsap.set(wrapper, { position: "relative" });
            wrapperTimeline.play()
          })
          .on( "mouseleave", () => {
            gsap.set(wrapper, { position: "absolute" });
            wrapperTimeline.reverse()
          })
      } );

      this.$images
        .on("mouseenter", (e) => timeline.play())
        .on("mouseleave", () => timeline.reverse());
      // this.$childLink
      //   .on("mouseenter", (e) => {
      //     if (this.currentFilter == $(e.currentTarget).data("filter")) return;
      //     const state = Flip.getState(
      //       `${this.selectors.grandChildLink},${this.selectors.images}`
      //     );
      //     // const megaMenuState = Flip.getState(this.selectors.images, {
      //     //   props: "height,width",
      //     // });

      //     this.$grandChildLink.removeClass("show");
      //     this.$images
      //       .find(
      //         `[data-filter-trigger="${$(e.currentTarget).data("filter")}"]`
      //       )
      //       .addClass("show");
      //     this.currentFilter = $(e.currentTarget).data("filter");

      //     this.$megaMenu.addClass("full");

      //     Flip.from(state, {
      //       duration: 0.4,
      //       scale: true,
      //       absolute: false,
      //       ease: this.ease,
      //       stagger: 0.1,
      //       simple: true,
      //       onEnter: (elements) =>
      //         gsap.fromTo(
      //           elements,
      //           { opacity: 0 },
      //           { opacity: 1, duration: 0.8, ease: this.ease }
      //         ),
      //       onLeave: (elements) =>
      //         gsap.to(elements, { opacity: 0, duration: 0.8, ease: this.ease }),
      //     });

      //     // Flip.from(megaMenuState, {
      //     //   duration: 0.4,
      //     //   scale: false,
      //     // });
      //   });
    }

    closeMegaMenu() {
      // const megaMenuState = Flip.getState( this.selectors.images, { props: "height" } );
      this.$grandChildLink.removeClass( "show" );
      // this.currentFilter = "";



      // Flip.from( megaMenuState, {
      //   duration: .4,
      //   scale: false,
      //   onComplete: function() {
      //     $('[data-mega-menu]').removeClass('full');
      //   }
      // } )

      this.megaMenuAnim.reverse();

    }

    moveDropdownMenu() {
      this.$dropdownMenu.each( ( i, e ) => {
        $( e ).prependTo( this.$wrapper );
      } )
    }

    initDropdownMenuuAnimation() {
      this.dropdownAnim = {};

      this.$dropdownMenu.each( ( i,e ) => {
        const id = $( e ).data( "dropdown-menu" );
        const childLinks = $( e ).find( this.selectors.dropdownChildLinks );

        this.dropdownAnim[id] = gsap.timeline({
          paused: true
        });

        gsap.set( childLinks, {
          opacity: 0,
        })

        this.dropdownAnim[id]
          .to( $( e ), { scaleY: 1, ease: this.ease, duration: 0.4 } )
          .to( childLinks, { opacity: 1, stagger: 0.1 }, "-=0.3" )
      } );
    }

    initDropdownMenuEvents() {
      this.$dropdownMenu.each( ( i,e ) => {
        const id = $( e ).data( "dropdown-menu" );
        const triggerElem = this.$element.find( `[data-trigger="${ id }"]` );

        triggerElem.on( "mouseenter", () => this.enterAnimation( this.dropdownAnim[id], false ) );
        triggerElem.on( "mouseleave", () => this.enterAnimation( this.dropdownAnim[id], true ) );
        $( e ).on( "mouseenter", () => this.enterAnimation( this.dropdownAnim[id], false ) );
        $( e ).on( "mouseleave", () => this.enterAnimation( this.dropdownAnim[id], true ) );
      } );
    }

    enterAnimation( timeline, reverse ) {
      if( this.currentTimeline !== timeline ) {
        if( this.currentTimeline ) {
          this.currentTimeline.reverse().then( () => {
            if( reverse )
              this.currentTimeline = timeline.reverse();
            else
              this.currentTimeline = timeline.play();
          } );
        }
        else {
          if( reverse )
            this.currentTimeline = timeline.reverse();
          else
            this.currentTimeline = timeline.play();
        }
      }
      else {
        if( reverse )
          this.currentTimeline = timeline.reverse();
        else
          this.currentTimeline = timeline.play();
      }
    }

    initCartTrigger() {
      if( this.$cart.hasClass( "has-icon" ) ) return;
      this.$cart.on( "mouseenter", () => {
        // const cartState = Flip.getState( this.$cart.find( ".cart__number, .cart__icon" ) );
        const cartState = Flip.getState( this.$cart.find( ".cart__number" ) );

        // this.$cart.find( ".cart__icon" ).hide();

        Flip.from( cartState, {
          // targets: this.$cart.find( ".cart__number, .cart__icon" ),
          targets: this.$cart.find( ".cart__number" ),
          duration: .4,
          scale: false,
          absolute: false,
          ease: this.ease,
          stagger: 0.1,
          onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {opacity: 1, scale: 1, duration: .4, ease: this.ease }),
          onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: .4, ease: this.ease })
        })
      })
      this.$cart.on( "mouseleave", () => {
        const cartState = Flip.getState( this.$cart.find( ".cart__number, .cart__icon" ) );

        // this.$cart.find( ".cart__icon" ).show();

        Flip.from( cartState, {
          // targets: this.$cart.find( ".cart__number, .cart__icon" ),
          targets: this.$cart.find( ".cart__number" ),
          duration: .4,
          scale: false,
          absolute: false,
          ease: this.ease,
          stagger: 0.1,
          onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {opacity: 1, scale: 1, duration: .4, ease: this.ease }),
          onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: .4, ease: this.ease })
        })
      })
    }
}

class MFRHeaderMobile {
  constructor( e ) {
    this.$element = $( e );

    this.selectors = {
      hamburger: ".mobile-menu-trigger",
      wrapper: ".mobile-menu",
      megaMenuWrapper: ".header__mega-menu-wrapper",
      accordionTitle: ".mobile-menu__accordion-title",
      accordionItem: ".mobile-menu__accordion-item",
      menu: ".mobile-menu__accordion-menu",
      cta: ".mobile-menu__cta",
      offcanvasMenu: ".offcanvas-menu",
    };

    this.init();
  }

  init() {
    this.$hamburger = this.$element.find( this.selectors.hamburger );
    this.$wrapper = $( "body" ).find( this.selectors.wrapper );
    this.$megaMenu = this.$element.find( this.selectors.megaMenuWrapper );
    this.$offcanvasMenu = $( this.selectors.offcanvasMenu );

    this.$hamburger.on( "click", this.__handleBurgerClick.bind( this ) );

    this.initMobileMenu();


    this.$offcanvasMenu.on("opened.zf.offCanvas", () =>
      this.$hamburger.attr("aria-expanded", "true")
    );
    this.$offcanvasMenu.on("close.zf.offCanvas", () =>
      this.$hamburger.attr("aria-expanded", "false")
    );
  }

  __handleBurgerClick( e ) {
    if (this.$hamburger.attr("aria-expanded") == "false")
      this.$offcanvasMenu.foundation("open");
    else
      this.$offcanvasMenu.foundation("close");

    // this.$hamburger.attr( "aria-expanded", this.$hamburger.attr( "aria-expanded" ) == "false" ? "true" : "false" );
  }

  initMobileMenu() {
    if( !this.$wrapper.length ) return;
    this.$megaMenu.append( this.$wrapper );
    this.$element.find( `${ this.selectors.accordionTitle }[data-accordion-item]` ).on( "click", (e) => e.preventDefault() );

    this.mobileMenuAnimation = gsap.timeline( {
      paused: true,
    } );

    this.mobileMenuAnimation
      .to( this.$wrapper, {
        scaleY: 1,
        ease: this.ease,
        duration: 0.4
      } )
      // .from( this.$element.find( this.selectors.accordionItem ), {
      //   opacity: 0,
      //   // xPercent: -100,
      //   stagger: 0.1,
      //   duration: 0.4,
      //   ease: this.ease
      // }, "-=0.3" )
      // .from( this.$element.find( this.selectors.cta ), {
      //   opacity: 0,
      //   // scale: 0,
      //   stagger: 0.1,
      //   duration: 0.4,
      //   ease: this.ease
      // }, "-=0.3" );
  }
}